/**
 * Shared display labels for campaign step types and outreach strategies.
 */

export const STEP_TYPE_LABELS: Record<string, string> = {
  connection_request: 'Connection Request',
  first_dm: 'First DM',
  follow_up_1: 'Follow-up 1',
  follow_up_2: 'Follow-up 2',
  follow_up_3: 'Follow-up 3',
}

export const STRATEGY_LABELS: Record<string, string> = {
  pain_agitate: 'Pain Agitate',
  mutual_value: 'Mutual Value',
  social_proof: 'Social Proof',
  curiosity_gap: 'Curiosity Gap',
  direct_expert: 'Direct Expert',
  challenge: 'Challenge',
  trojan_horse: 'Trojan Horse',
  mutual_connection: 'Mutual Connection',
}
